// removed by extract-text-webpack-plugin
module.exports = {"sea-buckthron":"#faa634","container":"marketing_container_2jSeF","contentContainer":"marketing_contentContainer_1ybfP","content":"marketing_content_3qJWa","big-logo":"marketing_big-logo_2xJEG","marketing":"marketing_marketing_u3rBS","media":"marketing_media_1Ytxi","orange":"marketing_orange_2-Dle","cards":"marketing_cards_3ndKb","card":"marketing_card_1-2fD","FlipBox":"marketing_FlipBox_2NOi1","FlipFront":"marketing_FlipFront_5Fkof","FlipBack":"marketing_FlipBack_1U5tA","lato-title":"marketing_lato-title_1ugDV lato-title","lato-oversize":"marketing_lato-oversize_2SufO lato-oversize"};


//////////////////
// WEBPACK FOOTER
// ./src/static/home/marketing/marketing.css
// module id = 445
// module chunks = 4